export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
  'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
  'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
  'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri',
  'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
  'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

// Separate California cities
const CALIFORNIA_CITIES = [
  'Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Fresno',
  'Sacramento', 'Long Beach', 'Oakland', 'Bakersfield', 'Anaheim',
  'Santa Ana', 'Riverside', 'Stockton', 'Irvine', 'Fremont',
  'San Bernardino', 'Modesto', 'Fontana', 'Oxnard', 'Moreno Valley',
  'Huntington Beach', 'Santa Clarita', 'Garden Grove', 'Santa Rosa',
  'Oceanside', 'Rancho Cucamonga', 'Ontario', 'Lancaster', 'Elk Grove',
  'Corona', 'Palmdale', 'Salinas', 'Pomona', 'Torrance', 'Hayward',
  'Escondido', 'Sunnyvale', 'Orange', 'Fullerton', 'Pasadena',
  'Thousand Oaks', 'Visalia', 'Simi Valley', 'Concord', 'Roseville',
  'Santa Clara', 'Vallejo', 'Victorville', 'Berkeley', 'El Monte',
  'San Mateo', 'Burbank', 'Santa Maria', 'Santa Barbara', 'Ventura',
  'Santa Monica', 'Santa Cruz', 'San Rafael', 'San Leandro', 'Redding',
  'Pleasanton', 'Petaluma', 'Newport Beach', 'Mountain View', 'Milpitas',
  'La Mesa', 'La Habra', 'Huntington Park', 'Hemet', 'Davis'
].sort();

// Other cities
const OTHER_CITIES = [
  // Alabama
  'Birmingham', 'Montgomery', 'Huntsville', 'Mobile', 'Tuscaloosa',
  
  // Alaska
  'Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan',
  
  // Arizona
  'Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Glendale', 'Gilbert', 'Tempe',
  
  // Arkansas
  'Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro',
  
  // Colorado
  'Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood',
  'Thornton', 'Arvada', 'Westminster', 'Pueblo', 'Centennial',
  
  // Connecticut
  'Bridgeport', 'New Haven', 'Hartford', 'Stamford', 'Waterbury',
  
  // Delaware
  'Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna',
  
  // Florida
  'Jacksonville', 'Miami', 'Tampa', 'Orlando', 'St. Petersburg',
  'Hialeah', 'Tallahassee', 'Fort Lauderdale', 'Port St. Lucie',
  'Cape Coral', 'Pembroke Pines', 'Hollywood', 'Miramar', 'Gainesville',
  'Coral Springs', 'Miami Gardens', 'Clearwater', 'Palm Bay', 'Pompano Beach',
  
  // Georgia
  'Atlanta', 'Augusta', 'Columbus', 'Macon', 'Savannah',
  'Athens', 'Sandy Springs', 'Roswell', 'Johns Creek', 'Albany',
  
  // Hawaii
  'Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Waipahu',
  
  // Idaho
  'Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello',
  
  // Illinois
  'Chicago', 'Aurora', 'Rockford', 'Joliet', 'Naperville',
  'Springfield', 'Peoria', 'Elgin', 'Waukegan', 'Cicero',
  
  // Indiana
  'Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel',
  
  // Iowa
  'Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City',
  
  // Kansas
  'Wichita', 'Overland Park', 'Kansas City', 'Olathe', 'Topeka',
  
  // Kentucky
  'Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington',
  
  // Louisiana
  'New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles',
  
  // Maine
  'Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn',
  
  // Maryland
  'Baltimore', 'Frederick', 'Rockville', 'Gaithersburg', 'Bowie',
  
  // Massachusetts
  'Boston', 'Worcester', 'Springfield', 'Lowell', 'Cambridge',
  'New Bedford', 'Brockton', 'Quincy', 'Lynn', 'Fall River',
  
  // Michigan
  'Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Lansing',
  'Ann Arbor', 'Flint', 'Dearborn', 'Livonia', 'Clinton',
  
  // Minnesota
  'Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington',
  
  // Mississippi
  'Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi',
  
  // Missouri
  'Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence',
  
  // Montana
  'Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte',
  
  // Nebraska
  'Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney',
  
  // Nevada
  'Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks',
  
  // New Hampshire
  'Manchester', 'Nashua', 'Concord', 'Dover', 'Rochester',
  
  // New Jersey
  'Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison',
  'Woodbridge', 'Lakewood', 'Toms River', 'Hamilton', 'Trenton',
  
  // New Mexico
  'Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell',
  
  // New York
  'New York City', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse',
  'Albany', 'New Rochelle', 'Mount Vernon', 'Schenectady', 'Utica',
  
  // North Carolina
  'Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem',
  'Fayetteville', 'Cary', 'Wilmington', 'High Point', 'Greenville',
  
  // North Dakota
  'Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo',
  
  // Ohio
  'Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron',
  'Dayton', 'Parma', 'Canton', 'Youngstown', 'Lorain',
  
  // Oklahoma
  'Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Edmond',
  
  // Oregon
  'Portland', 'Salem', 'Eugene', 'Gresham', 'Hillsboro',
  
  // Pennsylvania
  'Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading',
  'Scranton', 'Bethlehem', 'Lancaster', 'Harrisburg', 'Altoona',
  
  // Rhode Island
  'Providence', 'Warwick', 'Cranston', 'Pawtucket', 'East Providence',
  
  // South Carolina
  'Columbia', 'Charleston', 'North Charleston', 'Mount Pleasant', 'Rock Hill',
  
  // South Dakota
  'Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown',
  
  // Tennessee
  'Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville',
  
  // Texas
  'Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth',
  'El Paso', 'Arlington', 'Corpus Christi', 'Plano', 'Laredo',
  'Lubbock', 'Garland', 'Irving', 'Amarillo', 'Grand Prairie',
  'McKinney', 'Frisco', 'Brownsville', 'Pasadena', 'Mesquite',
  'McAllen', 'Killeen', 'Waco', 'Carrollton', 'Denton',
  
  // Utah
  'Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem',
  
  // Vermont
  'Burlington', 'South Burlington', 'Rutland', 'Barre', 'Montpelier',
  
  // Virginia
  'Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Newport News',
  'Alexandria', 'Hampton', 'Roanoke', 'Portsmouth', 'Suffolk',
  
  // Washington
  'Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue',
  'Kent', 'Everett', 'Renton', 'Yakima', 'Federal Way',
  
  // West Virginia
  'Charleston', 'Huntington', 'Parkersburg', 'Morgantown', 'Wheeling',
  
  // Wisconsin
  'Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine',
  
  // Wyoming
  'Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs'
].sort();

// Combine arrays with California cities first
export const US_CITIES = [
  ...CALIFORNIA_CITIES,
  ...OTHER_CITIES
];

// Helper function to check if a city is in California
export const isCaliforniaCity = (city) => CALIFORNIA_CITIES.includes(city); 